// extracted by mini-css-extract-plugin
export default {"networkInfoRow":"DeviceCurrentStatus_networkInfoRow__5N5TB"};